import { useEffect } from "react";
import { Trophy } from "lucide-react";
import confetti from "canvas-confetti";

export default function GoalCompletionSplash({ goalType, onComplete }) {
  useEffect(() => {
    // Trigger confetti
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });

    // Auto-dismiss after 3 seconds
    const timer = setTimeout(() => {
      onComplete?.();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  const goalLabels = {
    weight: "Weight Target",
    body_fat: "Body Fat Goal",
    chest: "Chest Goal",
    waist: "Waist Goal",
    hips: "Hips Goal",
    arms: "Arms Goal",
    thighs: "Thighs Goal",
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
      <div className="bg-white dark:bg-card rounded-3xl shadow-2xl p-8 text-center max-w-sm animate-bounce">
        <div className="flex justify-center mb-4">
          <div className="bg-primary/20 p-4 rounded-full">
            <Trophy className="w-12 h-12 text-primary" />
          </div>
        </div>
        <h2 className="text-2xl font-display font-bold mb-2">Congratulations!</h2>
        <p className="text-muted-foreground mb-1">You've completed your</p>
        <p className="text-lg font-semibold text-primary capitalize">{goalLabels[goalType]}</p>
        <p className="text-sm text-muted-foreground mt-4">Keep up the great work!</p>
      </div>
    </div>
  );
}